import React from "react"
import NavBar from "./NavBar.js"
import MobNavBar from "./MobNavBar.js"
import "normalize.css"
import "../styles/global.css"
import useWindowSize from '../hooks/useWindowSize'
import { useEffect } from "react"

function Layout(prop) {
  const { windowHeight } = useWindowSize();
  useEffect(() => {
    if (document && window) {
      const vh = windowHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`)
    }
  }, [windowHeight]
  )

  const bgcolor = prop.bgcolor;
  const { children } = prop;
  const linkStyle = prop.mosaic ? 'nav__link__m' : 'nav__link';
  const contentStyle = prop.contentStyle;

  return (
    <div className="layout" style={{ backgroundColor: bgcolor }}>
      <NavBar linkStyle={linkStyle} />
      <MobNavBar />
      <div className={contentStyle}>{children}</div>
    </div>
  )
}

export default Layout
